module.exports = __webpack_public_path__ + "img/camping_tent.f4ec28fe.svg";